var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreProductsGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.175 21.3914C16.6426 21.3914 21.075 16.959 21.075 11.4914C21.075 6.02378 16.6426 1.5914 11.175 1.5914C5.70738 1.5914 1.275 6.02378 1.275 11.4914C1.275 16.959 5.70738 21.3914 11.175 21.3914Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.171 18.4877L22.725 23.0417",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25723 12.0291C5.66427 11.9242 5.66427 11.0586 6.25723 10.9537C8.40546 10.5737 10.1141 8.90985 10.5803 6.74388L10.6161 6.57785C10.7444 5.98192 11.5788 5.97823 11.7122 6.57299L11.7556 6.76647C12.2392 8.92221 13.9482 10.572 16.0905 10.951C16.6865 11.0564 16.6865 11.9264 16.0905 12.0318C13.9482 12.4108 12.2392 14.0606 11.7556 16.2163L11.7122 16.4098C11.5788 17.0046 10.7444 17.0009 10.6161 16.405L10.5803 16.2389C10.1141 14.073 8.40546 12.4091 6.25723 12.0291Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreProductsGrey);
export default __webpack_public_path__ + "static/media/explore_products_grey.6b600b388ab1cb49e785ba672134b670.svg";
export { ForwardRef as ReactComponent };